// extracted by mini-css-extract-plugin
export default {"table_container":"TableMainResults_table_container__6v-N0","main_table":"TableMainResults_main_table__-cmc7","tabmain_tablele":"TableMainResults_tabmain_tablele__snaXY"};